import {Outlet} from 'react-router-dom';

import Header from '@common/layout/Header';
import Footer from '@common/layout/Footer';
import ProductBreadcrumbs from '@modules/piu/components/ProductBreadcrumbs';

import HeaderMenu from '@common/components/HeaderMenu';

const PiuLayout = () => {
  return (
    <div className="w-full h-full min-h-screen flex flex-col relative pb-10">
      <Header breadcrumbs={<ProductBreadcrumbs />}>
        <HeaderMenu />
      </Header>
      <Outlet />
      <Footer />
    </div>
  );
};

export default PiuLayout;
